"use strict";

import React from "react";
import ReactDOM from "react-dom";
//import PropTypes from 'prop-types';

import SliderBlock from './SliderBlock.jsx';
import CriticalIllnessExpenseCalcTop from './CriticalIllnessExpenseCalcTop.jsx';
import CriticalIllnessExpenseCalcBottomFloater from './CriticalIllnessExpenseCalcBottomFloater.jsx';
import CriticalIllnessExpenseCalcSummary from './CriticalIllnessExpenseCalcSummary.jsx';
import Utils from '../Utils.jsx';
//import style from './CriticalIllnessRecoveryExpenseCalc.scss';



/* --------------------------------------------------------------------------------------*/
class CriticalIllnessRecoveryExpenseCalc extends React.Component {


    constructor(props) {

        super(props);

        // bind addTodo once in constructor
        this.handleAllChangeEvents = this.handleAllChangeEvents.bind(this);
		this.detectTopVisibility = this.detectTopVisibility.bind(this);
		this.detectBottomVisibility = this.detectBottomVisibility.bind(this);
        this.state = {
            Accumulated_Savings: 0,
			Recovery_Time: 1,
			TopIsVisible: true,
			BottomIsVisible: true,
			Show_Floater: ""
			//,Show_Results: false
        };

		

        var rObj = {};

        ExpenseList.map(item => (
            rObj[item.id] = item.value
        ));

        this.state["Expense"] = rObj;
		
		
	}


	detectTopVisibility(isVisible) {

		this.setState({
			TopIsVisible: isVisible
		});

		var showOrNot = "";

		if (!isVisible && !this.state.BottomIsVisible) {
			showOrNot = "show";
		}

		this.setState({
			Show_Floater: showOrNot
		});
	}

	detectBottomVisibility(isVisible) {
		this.setState({
			BottomIsVisible: isVisible
		});

		var showOrNot = "";

		if (!isVisible && !this.state.TopIsVisible) {
			showOrNot = "show";
		}

		this.setState({
			Show_Floater: showOrNot
		});
	}
	

    handleAllChangeEvents(props) {
        var value = props.value;
        var id = props.id;

		//this.setState({ Show_Results: true });

        switch (id) {
            case "Accumulated_Savings":
                this.setState({
                    Accumulated_Savings: value
                });
                break;
            case "Recovery_Time":
                this.setState({
                    Recovery_Time: value
                });
                break;

            default:
                let ExpenseObj = Object.assign({}, this.state.Expense);
                ExpenseObj[id] = value;
                this.setState({
                    Expense: ExpenseObj
                });

                break;
        }

	}

	

    render() {

		var VisibilitySensor = require('react-visibility-sensor');

        var accumulatedSavings = this.state.Accumulated_Savings;
        var recoveryTime = this.state.Recovery_Time;
        var monthlyExpenses = 0;
        var monthsCovered = 0;
		var surplusBenefits = 0;
		var worriedThreshold = -50000;
        for (var key in this.state.Expense) {
            monthlyExpenses += parseInt(this.state.Expense[key]);
		}

		var totalExpenses = monthlyExpenses * recoveryTime;

        surplusBenefits = accumulatedSavings - totalExpenses;

		monthsCovered = (accumulatedSavings / monthlyExpenses) - recoveryTime;

		var showResults = false;

		if (monthlyExpenses == 0) {
			showResults = false;
		} else {
			showResults = true;
		}

		var expenseCalcSummary;
		var bottomFloater;

		if (showResults) {
			expenseCalcSummary = <VisibilitySensor onChange={this.detectBottomVisibility}
				scrollCheck={true}
				resizeCheck={true}
				partialVisibility={'bottom'}
			>
				
				<CriticalIllnessExpenseCalcSummary
					Surplus_Deficit={surplusBenefits}
					Worried_Threshold={worriedThreshold}
					Savings_Left={accumulatedSavings - totalExpenses}
					Recovery_Time={recoveryTime}
					Accumulated_Savings={accumulatedSavings}
					Total_Expenses={totalExpenses}
				/>
			</VisibilitySensor>

			bottomFloater = <CriticalIllnessExpenseCalcBottomFloater 
				Surplus_Deficit={surplusBenefits}
				Worried_Threshold={worriedThreshold}
				Total_Expenses={totalExpenses}
				Show={this.state.Show_Floater} />

			//bottomFloater = <ExpenseCalcBottomFloater Monthly_Expenses={monthlyExpenses}
			//	Months_Covered={monthsCovered}
			//	Surplus_Deficit={surplusBenefits}
			//	Worried_Threshold={worriedThreshold}
			//	Show={this.state.Show_Floater} />
		}

		return <div>
			<div className="site-wrapper section-criticalillnessexp criticalillnessexp inside-page">
                <div className="site-wrapper-inner">
					<div className="ui container" >
						<VisibilitySensor onChange={this.detectTopVisibility}
							scrollCheck={true}
							resizeCheck={true}
							partialVisibility={'top'}
							offset={{ bottom: 100 }}
						>
							<CriticalIllnessExpenseCalcTop								
								Surplus_Deficit={surplusBenefits}
								Worried_Threshold={worriedThreshold}
								Total_Expenses={totalExpenses}
								Show_Results={showResults}
							/>
						</VisibilitySensor>

                    </div>
                </div>
            </div>
            <div className="ui container article-content critillness-calc">
                <h1>RECOVERY EXPENSES CALCULATOR</h1>
                <div className="row savings_recovery">
                    <div className="col-sm-6">
                        <SliderBlock onChange={this.handleAllChangeEvents}
                            id="Accumulated_Savings"
                            type="currency"
                            sliderCSS="sliderblock"
                            min={0}
                            max={500000}
                            step={5000}
                            value={this.state.Accumulated_Savings}
                            title="Accumulated Savings"
                            infoText={
                                <div>
                                    <h3>Accumulated Savings</h3>
                                    <p>This includes all cash, or near-cash assets at your immediate disposal.</p>
                                </div>
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <SliderBlock onChange={this.handleAllChangeEvents}
                            id="Recovery_Time"
                            type="daterange"
                            sliderCSS="sliderblock"
                            min={1}
                            max={60}
                            step={1}
                            value={this.state.Recovery_Time}
                            title="Recovery time away from work"
                            infoText={
                                <div>
                                    <h3>Recovery time away from work</h3>
                                    <p>On average, Canadians are absent from work for about SIX MONTHS after a cancer diagnosis.  However, this time can vary greatly according to the type and severity of the disease.</p>
                                </div>
                            }
                        />
					</div>
					
				</div>
				<div className="row expenses">
					<h2>MONTHLY EXPENSES</h2>
					{
						ExpenseList.map(item => (
							<React.Fragment key={item.id}>
								<div className="col-sm-6 col-lg-4">
									<SliderBlock onChange={this.handleAllChangeEvents}
										id={item.id}
										type={item.type}
										sliderCSS={item.sliderCSS}
										min={item.min}
										max={item.max}
										step={item.step}
										value={this.state.Expense[item.id]}
										title={item.title}
										infoText={item.infoText}
									/>
								</div>
							</React.Fragment>
						))
					}
				</div>
                

				{expenseCalcSummary}

				{bottomFloater}

				<h3 id="ci-calc-back"><a href="../" style={{ textDecoration: 'none' }}><i className="fa fa-arrow-circle-left"></i> Back</a></h3>

            </div>

			

			

			

        </div>

    }
}


const ExpenseList = [
    {
        id: "Rent_Mortgage",
        type: "currency",
        sliderCSS: "sliderblock",
        min: 0,
        max: 10000,
        step: 100,
        value: 0,
		title: "Rent/Mortgage",
		infoText:
			<div>
				<h1>Rent/Mortgage</h1>
				<p>Monthly payments for rent or mortgage at your principal residence.</p>
			</div>
    },
    {
        id: "Loans_CC",
        type: "currency",
        sliderCSS: "sliderblock",
        min: 0,
        max: 10000,
        step: 100,
        value: 0,
		title: "Debts",
		infoText:
			<div>
				<h1>Debts</h1>
				<p>Monthly payments to service debt and loan obligations</p>
				<ul>
					<li>Loans</li>
					<li>Lines of credit</li>
					<li>Credit cards</li>
				</ul>
			</div>
    },
    {
        id: "Property_Cost",
        type: "currency",
        sliderCSS: "sliderblock",
        min: 0,
        max: 2500,
        step: 100,
        value: 0,
		title: "Property taxes/condo fees",
		infoText:
			<div>
				<h1>Property taxes/condo fees</h1>
				<p>The amount you pay in city taxes and maintenance fees for any residence(s) you own.</p>
			</div>
    },
    {
		id: "Groceries",
        type: "currency",
        sliderCSS: "sliderblock",
        min: 0,
        max: 2500,
        step: 100,
        value: 0,
		title: "Groceries/Eating out",
		infoText:
			<div>
				<h1>Groceries/Eating out</h1>
				<p>An average monthly amount that you spend on groceries and eating out at restaurants.</p>
			</div>
    },
    {
        id: "Child_Care",
        type: "currency",
        sliderCSS: "sliderblock",
        min: 0,
        max: 5000,
        step: 100,
        value: 0,
		title: "Child Care",
		infoText:
			<div>
				<h1>Child Care</h1>
				<p>Your monthly cost for child care expenses including daycare and/or babysitting.</p>
			</div>
	},
	{
		id: "Additional_Medical_Expenses",
		type: "currency",
		sliderCSS: "sliderblock",
		min: 0,
		max: 2000,
		step: 100,
		value: 0,
		title: "Treatment Expenses",
		infoText:
			<div>
				<h1>Miscellaneous Treatment Expenses</h1>
				<p>This includes any medical expenses not covered by MSP or private health insurance:</p>
				<ul>
					<li>Medications</li>
					<li>Caregiver/Nursing services</li>
					<li>Medical equipments</li>
					<li>Travel to treatment centre</li>
				</ul>
			</div>
	},
	{
		id: "Loss_of_Income",
		type: "currency",
		sliderCSS: "sliderblock",
		min: 0,
		max: 10000,
		step: 100,
		value: 0,
		title: "Spousal Income Loss",
		infoText:
			<div>
				<h1>Spousal Income Loss</h1>
				<p>This is the monthly amount of income your spouse or partner would lose if they took time off work to care for you as you recover.</p>
			</div>
	},
	{
		id: "Other_Expenses",
		type: "currency",
		sliderCSS: "sliderblock",
		min: 0,
		max: 2000,
		step: 100,
		value: 0,
		title: "Other Expenses",
		infoText:
			<div>
				<h1>Other Monthly Expenses</h1>
				<p>Include any expenses not covered in the other categories.</p>
				<ul>
					<li>Gas</li>
					<li>Life Insurance</li>
					<li>Entertainment</li>
					<li>Utilities</li>
					<li>Internet/Cell phone/Cable</li>
				</ul>
			</div>
	}


];


const App = <CriticalIllnessRecoveryExpenseCalc  />
ReactDOM.render(
    App,
    document.getElementById('AppContainer')
);